import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import BgImg from "../../../images/case-studies/cmore/ellipse_left.png";
import { StaticImage } from "gatsby-plugin-image";

const Challengecmore = () => {
  return (
    <div
      className="challenge_cmore p-100"
      style={{ backgroundImage: `url(${BgImg})`, backgroundColor: "#000" }}
    >
      <Container>
        <Row>
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto">
            <h2>
              Project <span>Challenges</span>
            </h2>
            <p>
              Although the whole development process was quite smooth but there
              have been some challenges as follows
            </p>
            <ul>
              <li>
                Designing workflows to accommodate the intricate and diverse
                procurement processes in the construction industry, including
                bulk orders, custom specifications, and site-specific
                deliveries.
              </li>
              <li>
                Ensuring accurate and real-time inventory management for a wide
                range of construction materials, considering fluctuating stock
                levels and frequent purchases.
              </li>
              <li>
                Implementing robust security measures to ensure the safety of
                financial transactions, and safeguarding sensitive information
                during payments on the platform.
              </li>
            </ul>
          </Col>
          <Col xs={12} md={6} lg={7} xl={7} xxl={7} className="my-auto">
            <div className="idea_img">
              <StaticImage
                src="../../../images/case-studies/cmore/challenges.png"
                alt="TekRevol"
                className="img-fluid d-none d-md-block"
                layout="constrained"
                placeholder="blurred"
                formats={["png"]}
                width={755}
              />
              <StaticImage
                src="../../../images/case-studies/cmore/challenge_mob.png"
                alt="TekRevol"
                className="img-fluid d-sm-block d-md-none"
                layout="constrained"
                placeholder="blurred"
                formats={["png"]}
                width={755}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Challengecmore;
